﻿(function (angular) {
    'use strict';

    angular.module('Toyota.Directives')
        .directive('gtmClick', [function () {
            gtmClickController.$inject = ['$attrs', '$element', '$analytics', 'GtmDetails'];
            function gtmClickController($attrs, $element, $analytics, GtmDetails) {

                function getEventHandler(controlType) {
                    switch (controlType) {
                        case 'input':
                        case 'tag input':
                        case 'form input':
                        case 'select':
                            return 'blur';
                        case 'button':
                        case 'link':
                            return 'click';
                        case 'checkbox':
                            return 'change';
                        case 'ui-select':
                            return 'ui-select-blur';
                        default:
                            return '';
                    }
                }

                function init() {
                    var eventControlType = $attrs.gtmControlType ? $attrs.gtmControlType : $attrs.gtmCategory;
                    var eventHandler = getEventHandler(eventControlType);

                    $element.on(eventHandler, function () {
                        var gtmDetails = GtmDetails($element[0]);

                        var properties = {
                            eventCategory: gtmDetails.category,
                            eventAction: gtmDetails.action,
                            eventLabel: gtmDetails.label
                        };

                        if (gtmDetails.extraProps) {
                            angular.extend(properties, gtmDetails.extraProps);
                        }

                        $analytics.eventTrack('gaClick', properties);
                    });
                }

                init();
            }

            return {
                restrict: 'A',
                controller: gtmClickController,
                controllerAs: 'gcc',
                bindToController: true,
                link: function (scope, element, attrs) {

                }
            };
        }]);
})(window.angular);